import React from 'react';

import Responsive from '@/components/Responsive';

import DetailsLayoutDesktop from './DetailsLayout.desktop';
import DetailsLayoutMobile from './DetailsLayout.mobile';
import { DetailsLayoutProps } from './types';

const DetailsLayout: React.FC<DetailsLayoutProps> = (props) => {
  return (
    <Responsive>
      <Responsive.Default>
        <DetailsLayoutDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <DetailsLayoutMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
};

export default DetailsLayout;
